var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid padding-0",staticStyle:{"margin-top":"-15px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }